'use client';

import { type RawProductQuery } from '@packages/gql/generated/shopping/graphql';
import { useIntl } from 'react-intl';
import type { DividerProps } from '@packages/shared/src/ui/Divider/Divider';
import type { ReactElement } from 'react';
import { additionalServicesMessages } from './AdditionalServices.client.messages';
import type { AdditionalInfoItemProps } from '../AdditionalInfoItem/AdditionalInfoItem.client';
import { AdditionalInfoItem } from '../AdditionalInfoItem/AdditionalInfoItem.client';
import { getValidInfoList } from '../getValidInfoList/getValidInfoList';

/* GraphQL */ `
  fragment AdditionalServicesFragment on AdditionalServicesInfo {
    infoList {
      serviceLayerId
      translationKey
      iconUrl
    }
  }
`;

export type AdditionalServicesProps = {
  infoList: NonNullable<
    NonNullable<NonNullable<RawProductQuery['product']>['additionalInfo']>['additionalServices']
  >['infoList'];
  divider?: ReactElement<DividerProps>;
} & Pick<AdditionalInfoItemProps, 'dialogTitle'>;

export const AdditionalServices = ({ infoList, divider, dialogTitle }: AdditionalServicesProps) => {
  const { formatMessage } = useIntl();

  if (infoList.length === 0) return null;

  const validInfoList = getValidInfoList(infoList, additionalServicesMessages);

  if (validInfoList.length === 0) return null;

  return (
    <>
      {divider}
      <div className="flex flex-col flex-nowrap items-start gap-2">
        {validInfoList.map((item) => (
          <AdditionalInfoItem
            key={item.translationKey}
            icon={item.iconUrl}
            serviceLayerId={item.serviceLayerId}
            text={formatMessage(item.messageDescriptor, {
              bold: (chunks: React.ReactNode) => <b>{chunks}</b>,
            })}
            dialogTitle={dialogTitle}
          />
        ))}
      </div>
    </>
  );
};
